import type { PreloadedQuery } from 'react-relay';
import type { csmFolderSearchArticlesForSupportSiteQuery } from './__generated__/csmFolderSearchArticlesForSupportSiteQuery.graphql';
import type { emptyStateQuery } from './__generated__/emptyStateQuery.graphql';
import type { emptyStateRenderer_data$key } from './__generated__/emptyStateRenderer_data.graphql';
import type { mainCsmFolderItemsRenderer_data$key } from './__generated__/mainCsmFolderItemsRenderer_data.graphql';

export interface CsmFolderQueryProps {
	queryReference: PreloadedQuery<csmFolderSearchArticlesForSupportSiteQuery>;
}

export interface CsmEmptyFolderQueryProps {
	queryReference: PreloadedQuery<emptyStateQuery>;
}

export interface CsmFolderItemsRendererProps {
	csmFolderKey: mainCsmFolderItemsRenderer_data$key;
}

export interface EmptyStateRendererProps {
	csmFolderKey: emptyStateRenderer_data$key;
}

export const MAX_ITEMS_PER_PAGE = 24;
